import { webApi } from "../../../../core/http/httpThunks";
import { EarningsApiResponse } from "../types";

export const getSecurityEarningsApi = (userId: string, symbol: string, endpoint: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<EarningsApiResponse>({
    method: "GET",
    url: "reporting/getsecurityinfo",
    params: {
      userId,
      symbol,
      endpoint
    },
  });
};

export default getSecurityEarningsApi;
